import { render, staticRenderFns } from "./AlarmEventNotificationsSubExplainer.vue?vue&type=template&id=c13fc244&scoped=true&"
import script from "./AlarmEventNotificationsSubExplainer.vue?vue&type=script&lang=ts&"
export * from "./AlarmEventNotificationsSubExplainer.vue?vue&type=script&lang=ts&"
import style0 from "./AlarmEventNotificationsSubExplainer.vue?vue&type=style&index=0&id=c13fc244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13fc244",
  null
  
)

export default component.exports